import { filesize } from 'filesize'
import AttachmentData = App.Data.AttachmentData

export function fileIcon(attachment: AttachmentData): string {
  const fileType = [attachment.mime_type, attachment.extension, attachment.filename]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

  if (fileType.includes('pdf')) return 'pi pi-file-pdf'
  if (fileType.includes('image') || /\b(jpe?g|png|gif|webp|svg)\b/.test(fileType)) return 'pi pi-image'
  if (fileType.includes('excel') || /\b(xls|xlsx|csv)\b/.test(fileType)) return 'pi pi-file-excel'
  if (fileType.includes('word') || /\b(doc|docx)\b/.test(fileType)) return 'pi pi-file-word'

  return 'pi pi-file'
}

export function formatFileSize(size: number | undefined, locale: string): string {
  return size == null ? '' : filesize(size, { locale })
}

export function formatUploadDate(updatedAt: string | undefined | null, locale: string): string {
  return updatedAt ? new Date(updatedAt).toLocaleDateString(locale, { dateStyle: 'short' }) : ''
}
